<template>
  <div class="shareholder">
    <a-card style="margin-top: 10px">
        <a-row :gutter="20">
          <a-col>
            <div class="estimate-list">
              <div class="estimate-question">
                <a-row :gutter="10" style="width: 100%; text-align: center">
                  <a-col :span="6" style="background: #f3f3f3;">
                    <span style="margin-left: -30px;">最小值</span>
                  </a-col>
                  <a-col :span="6" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">最大值</span>
                  </a-col>
                  <a-col :span="6" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">
                      等&nbsp;&nbsp;&nbsp;&nbsp;级
                    </span>
                  </a-col>
                  <a-col :span="6" style="background: #f3f3f3;">
                    <span style="margin-left: -30px">风险系数</span>
                  </a-col>
                </a-row>
              </div>
              <div style="width: 140px;text-align: center;margin-left: -30px;">
                <div style="width:100%;background: #f3f3f3;">操作</div>
              </div>
            </div>
            <div
              class="estimate-list"
              v-for="(scoreResult, index) in modalForm"
              :key="index"
            >
              <div style="margin-right: 10px;  margin-top: -20px">{{ index + 1 }}</div>
              <div class="estimate-question">
                <div v-if="index == 0" style="height: 5px;"></div>
                <a-row :gutter="10">
                  <a-col :span="6">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-input-number
                          controls-position="right"
                          v-model="scoreResult.minScore"
                          :step="1"
                          max="10000000000" min="0"
                          style="width: 200px; height: 30px"
                          :disabled="index == 0 ? true : false"
                          :style="index == 0 ? 'background: #f3f3f3;' : ''"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" label-width="0px">
                    <a-form-item>
                      <a-tooltip placement="topLeft">
                        <a-input-number
                          controls-position="right"
                          v-model="scoreResult.maxScore"
                          :step="1"
                          max="10000000000" min="0"
                          style="width: 200px; height: 30px"
                          :disabled="
                            index == modalForm.length - 1 ? true : false
                          "
                          :style="
                            index == modalForm.length - 1
                              ? 'background: #f3f3f3;'
                              : ''
                          "
                          @change="copyMax(scoreResult, index)"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-select
                          placeholder="请选择等级"
                          v-model="scoreResult.grade"
                          style="width: 200px; height: 30px"
                        >
                          <a-select-option
                            v-for="item in objectList"
                            :value="item.text"
                            :key="item.text"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-input-number
                          controls-position="right"
                          v-model="scoreResult.risk"
                          :step="1"
                          maxlength="20"
                          style="width: 200px; height: 30px"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <div class="estimate-button">
                <a-tooltip placement="topLeft">
                  <template #title>新增分值区间</template>
                  <img
                    src="./images/add.png"
                    style="width: 20px; height: 20px"
                    @click="addScoreResult"
                    v-if="index != modalForm.length - 1"
                  />
                </a-tooltip>
                <a-tooltip placement="topLeft">
                  <template #title>删除分值区间</template>
                  <img
                    src="./images/delete.png"
                    style="width: 20px; height: 20px;"
                    @click="removeScoreResult(scoreResult)"
                    v-if="index != modalForm.length - 1 && index != 0"
                  />
                </a-tooltip>
              </div>
            </div>
          </a-col>
          <a-row style="color: red; margin-top: 10px;margin-left: 28px;">
            <a-col>
              注：1、分值区间的开始最小值必须等于上一个结束的最大值，例如：10 至
              60 ，60 至 90，90 至 100
            </a-col>
            <a-col style="padding-left: 28px">
              2、每条分值区间包小不包大，及 最小值 &lt;= 值 &lt; 最大值
            </a-col>
            <a-col style="padding-left: 28px">
              3、分值区间第一条不能填写最小值
            </a-col>
            <a-col style="padding-left: 28px">
              4、分值区间最后一条不能填写最大值
            </a-col>
          </a-row>
        </a-row>

    </a-card>
        <!-- 提交 -->
    <footer-tool-bar>
      <a-button @click="checkDate" >
        提交
      </a-button>
    </footer-tool-bar>
  </div>
</template>
<script>
import mixin from './mixin'
import { page, addTable, update } from './api'
import FooterToolBar from 'components/FooterToolBar.vue'

export default {
  mixins: [mixin],
  data() {
    return {
      tableData: [],
      modalForm: [],
      visible: false,
      disabled: false,
      objectList: [
        {
          text: 'AAA',
          value: '1',
        },
        {
          text: 'AA+',
          value: '2',
        },
        {
          text: 'AA',
          value: '3',
        },
        {
          text: 'AA-',
          value: '4',
        },
        {
          text: 'A+',
          value: '5',
        },
        {
          text: 'A',
          value: '6',
        },
        {
          text: 'A-',
          value: '7',
        },
        {
          text: 'BBB',
          value: '8',
        },
        {
          text: 'BB',
          value: '9',
        },
        {
          text: 'B',
          value: '10',
        },
      ],
    }
  },
  components: {
    FooterToolBar,
  },
  mounted() {
    this._getPage()
  },
  methods: {
    _getPage() {
      const { current, pageSize } = this.pageData
      const formData = {
        size: pageSize,
        current,
      }
      page(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.index = this.index+1;
        this.tableData = records
        this.goToSetting(records)
      })
    },

    // 设置分值区间
    goToSetting(date) {
      this.modalForm = []
      if (date.length > 0) {
        this.modalForm = date
      } else {
        this.modalForm.push(
        {
          minScore: null,
          maxScore: null,
          grade: null,
          risk: null,
        },
        {
          minScore: null,
          maxScore: null,
          grade: null,
          risk: null,
        },
        {
          minScore: null,
          maxScore: null,
          grade: null,
          risk: null,
        },
        ) 
      }   
    },

    //上一行最大值=下一行最小值
    copyMax(scoreResult, index) {
      let i = 0
      const nextIndex = index + 1
      for (; i < this.modalForm.length; i++) {
        if (i === nextIndex) {
          this.modalForm[i].minScore = scoreResult.maxScore
        }
      }
    },

    // 提交
    checkDate(){
      for (var i = 0; i < this.modalForm.length; i++) {
          if (i == 0) {
            if (
              this.modalForm[i].maxScore == null ||
              this.modalForm[i].maxScore == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最大值补充完整',
              })
              return false
            }
          } else if (i == this.modalForm.length - 1) {
            if (
              this.modalForm[i].minScore == null ||
              this.modalForm[i].minScore == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最小值补充完整',
              })
              return false
            }
            // 校验最后一行最小值是否与上一行最大值相同
            if (
              this.modalForm[i].minScore !=
              this.modalForm[i - 1].maxScore
            ) {
              this.$notification.warning({
                message: '提示',
                description:
                  '第' + (i + 1) + '行最小值必须等于第' + i + '行的最大值',
              })
              return false
            }
          } else {
            if (
              this.modalForm[i].minScore == null ||
              this.modalForm[i].minScore == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最小值补充完整',
              })
              return false
            }
            if (
              this.modalForm[i].maxScore == null ||
              this.modalForm[i].maxScore == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最大值补充完整',
              })
              return false
            }
            // 校验本行最小值必须大于最大值
            if (
              parseFloat(this.modalForm[i].minScore) >=
              parseFloat(this.modalForm[i].maxScore)
              // this.modalForm[i].minScore >=
              // this.modalForm[i].maxScore
            ) {
              this.$notification.warning({
                message: '提示',
                description: '第' + (i + 1) + '行最小值必须小于最大值',
              })
              return false
            }
            // 校验本行最小值是否与上一行最大值相同
            if (
              this.modalForm[i].minScore !=
              this.modalForm[i - 1].maxScore
            ) {
              this.$notification.warning({
                message: '提示',
                description:
                  '第' + (i + 1) + '行最小值必须等于第' + i + '行的最大值',
              })
              return false
            }
          }
          // 校验等级是否填写
          if (
            this.modalForm[i].grade == null ||
            this.modalForm[i].grade == undefined
          ) {
            this.$notification.warning({
              message: '提示',
              description: '请将第' + (i + 1) + '行的等级补充完整',
            })
            return false
          }
          // 校验系数是否填写
          if (
            this.modalForm[i].risk == null ||
            this.modalForm[i].risk == undefined
          ) {
            this.$notification.warning({
              message: '提示',
              description: '请将第' + (i + 1) + '行的系数补充完整',
            })
            return false
          }
        }
        this.handleSubmitSetting();
    },
    async handleSubmitSetting() {
      const sunmitTable = {
        newCustomGradingList: this.modalForm,
      }
      console.log(111,sunmitTable);
      if(this.tableData.length > 0){
        await update(sunmitTable);
      }else{
        await addTable(sunmitTable);
      }
      this.$message.success('成功')
      this._getPage()
    },

    // 新增一行
    addScoreResult() {
      this.modalForm.push({
        minScore: null,
        maxScore: null,
        grade: null,
        risk: null,
      })
    },
    // 删除分值区间
    removeScoreResult(item) {
      let index = this.modalForm.indexOf(item)
      if (index !== -1) {
        this.modalForm.splice(index, 1)
      }
    },
  },
}
</script>
<style lang="less" scoped>
.estimate-list {
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.estimate-question {
  width: calc(100% - 140px);
}
.estimate-button {
  width: 50px;
  height: 40px;
  // line-height: 36px;
  // margin-left: 12px;
  margin-top: -20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.shareholder {
  /deep/ .margin-left-20 {
    margin-left: 20px;
  }
  .client-center-home
    /deep/
    .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    line-height: 30px;
  }
  /deep/ .edit-btns {
    text-align: right;
    width: 98.5%;
  }
  /deep/.margin-bottom-20 {
    margin-bottom: 20px;
  }
  /deep/ .editable-row-operations a {
    margin-right: 8px;
  }
  /deep/ .shareholder-add-btn {
    margin-top: 20px;
    .editable-add-btn {
      width: 100%;
    }
  }
}
/deep/ .editable-row-operations a {
  margin-right: 8px;
}
/deep/ .margin-top-20 {
  margin-top: 20px;
}
/deep/ .width-100 {
  width: 100%;
}
</style>
